import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import io from "socket.io-client";
import { apiUrl } from "../config/apiUrl";
import { saveNewNotification } from "../store/common/commonSlice";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const {
    access_token: accessToken,
    isLogin,
    user,
  } = useSelector((state) => state.authReducer);
  const { newNotifications } = useSelector((state) => state.commonReducer);
  const socketRef = useRef(null);
  const [deviceId, setDeviceId] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const loadFingerprint = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      const deviceId = result.visitorId;
      setDeviceId(deviceId);
    };

    loadFingerprint();
  }, []);

  useEffect(() => {
    if (isLogin && deviceId && !socketRef.current) {
      socketRef.current = io(apiUrl, { transports: ["websocket"] });
      socketRef.current.emit("join", { id: user?._id, deviceId });
      return () => {
        if (socketRef.current) {
          socketRef.current.emit("disconnected");
          // i am running disconnect because it is not emitting disconnected
          // socket i am not ending deviceId in disconnect while app will be sending
          // as disconnect does not send any data
          socketRef.current.disconnect();
          socketRef.current = null;
        }
      };
    }
  }, [isLogin, deviceId]);

  useEffect(() => {
    if (isLogin && socketRef.current) {
      socketRef.current.on("new-notification", (notification) => {
        dispatch(saveNewNotification(newNotifications + 1));
      });
    }
    return () => {
      socketRef.current?.off("new-notification");
    };
  }, [isLogin, newNotifications, dispatch]);

  return (
    <WebSocketContext.Provider value={{ socketRef, deviceId }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => useContext(WebSocketContext);
